import { render, staticRenderFns } from "./NewPluginTable.vue?vue&type=template&id=96fe7b8e&scoped=true"
import script from "./NewPluginTable.vue?vue&type=script&lang=js"
export * from "./NewPluginTable.vue?vue&type=script&lang=js"
import style0 from "./NewPluginTable.vue?vue&type=style&index=0&id=96fe7b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe7b8e",
  null
  
)

export default component.exports